/**
 * The BB mark as a corner signature (Gordon 2026-10-29: "put the BB logo in
 * the corner like a signature, not center. artist are center"). The vector
 * logo is used as a CSS mask, so it takes the theme's text colour in every
 * theme instead of being a fixed black or white image.
 */
import { cn } from "@/lib/utils";

export function BBSignature({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn("pointer-events-none block aspect-[812/928] bg-foreground -rotate-6 opacity-90 drop-shadow", className)}
      style={{
        WebkitMaskImage: "url(/brand/bb-logo.svg)",
        maskImage: "url(/brand/bb-logo.svg)",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
      }}
    />
  );
}
